
function CommunitySalesOfficeCalculateTime() {
    var retVal = "";
    

    var openTime = $("#communitySalesOfficeStatus").attr("data-open-time");
    var closeTime = $("#communitySalesOfficeStatus").attr("data-close-time");
    var color = "#94C947";

    if (openTime === null || closeTime === null ||
        typeof (openTime) != "string" || typeof (closeTime) != "string") {
        retVal = "N/A";
    }
    else {

        if ((openTime == "Only" && closeTime == "Appointment") ||
            (openTime == "Appointment" && closeTime == "Only")) {
            retVal = "Call for Appointment";
            color = "#005596";
        }
        else {
            var now = new Date();
            var openDateTime = CommunitySalesOfficeParseTimeString(now, openTime);
            var closedDateTime = CommunitySalesOfficeParseTimeString(now, closeTime);

            var openDateTimeDiff = Math.round((openDateTime.getTime() - now.getTime()) / 60000);
            var closeDateTimeDiff = Math.round((closedDateTime.getTime() - now.getTime()) / 60000);

            if (openDateTimeDiff > 30) {
                retVal = "Closed";
                color = "#414244";
            }
            else if (openDateTimeDiff <= 30 && openDateTimeDiff > 0) {
                retVal = "Opening Soon";
            }
            else if (openDateTimeDiff <= 0 && closeDateTimeDiff > 30) {
                retVal = "Open";
            }
            else if (closeDateTimeDiff > 0 && closeDateTimeDiff <= 30) {
                retVal = "Closing Soon";
            }
            else {
                retVal = "Closed";
                color = "#414244";
            }
        }
    }

    var communitySalesOfficeButton = $("#communitySalesOfficeStatusText");
    communitySalesOfficeButton.html(retVal);
    communitySalesOfficeButton.css("background-color", color)
}

function CommunitySalesOfficeParseTimeString(baseDate, timeString) {
    var isAm = timeString.includes(" AM") ? true : false;
    var timestring = timeString.split(" ")[0]
    var timeStringHours = Number(timestring.split(":")[0]);
    if (timeStringHours == 12 && isAm) {
        timeStringHours = 0;
    }
    else if (!isAm && timeStringHours < 12) {
        timeStringHours += 12;
    }

    var timeStringMinutes = Number(timestring.split(":")[1]);
    var parsedDateTime = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), timeStringHours, timeStringMinutes, 0, 0);
    return parsedDateTime;
}